import { render, staticRenderFns } from "./index_old.vue?vue&type=template&id=33224f73&scoped=true"
import script from "./index_old.vue?vue&type=script&lang=js"
export * from "./index_old.vue?vue&type=script&lang=js"
import style0 from "./index_old.vue?vue&type=style&index=0&id=33224f73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33224f73",
  null
  
)

export default component.exports